//#region src/components/Header/navState.ts
var e = (e) => (e.children?.length ?? 0) > 0 || (e.columns?.length ?? 0) > 0, t = (e) => e.kind === "cyo", n = (e, t) => e?.find((e) => e.key === t), r = (n, { activeKeys: r = [], persistentKeys: i = [], openKeys: a = [] }) => n.flatMap((n) => {
	let o = n.children?.some(t) ?? !1, s = i.includes(n.key);
	return [{
		key: n.key,
		parentKey: null,
		isShown: s || a.includes(n.key),
		levelIndex: 1,
		label: n.label,
		isCYO: o,
		hasContent: e(n),
		isPersistent: s,
		isActive: r.includes(n.key)
	}, ...(n.children ?? []).map((t) => ({
		key: t.key,
		parentKey: n.key,
		isShown: !1,
		levelIndex: 2,
		label: t.label,
		isCYO: o,
		hasContent: e(t),
		isPersistent: !1,
		isActive: r.includes(t.key)
	}))];
}), i = (e) => {
	e((e) => e.map((e) => ({
		...e,
		isShown: e.isPersistent
	})));
}, a = (e, t) => {
	e((e) => e.map((e) => ({
		...e,
		isShown: e.key === t.key || e.key === t.parentKey
	})));
}, o = (e, t) => {
	e((e) => e.map((e) => ({
		...e,
		isShown: e.key === t.parentKey
	})));
}, s = (e) => {
	clearTimeout(e.current), e.current = void 0;
}, c = (e, t, n) => {
	s(e), t((e) => e.map((e) => ({
		...e,
		isShown: (e.key === n.key || e.key === n.parentKey) && e.hasContent
	})));
}, l = (e, t, n) => {
	s(e), e.current = setTimeout(() => {
		t((e) => e.map((e) => ({
			...e,
			isShown: n.parentKey ? e.key === n.parentKey : e.isPersistent
		})));
	}, 500);
}, u = (e, t, n) => ({
	"aria-expanded": e.isShown,
	"aria-label": n(t)
});
//#endregion
export { r as createLevelStates, u as getAriaProps, n as getLevelState, c as handleMouseEnter, l as handleMouseLeave, a as handleNextLevelClick, o as handlePrevLevelClick, e as hasContent, t as isCyoItem, i as resetLevelStates };
